// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aFmVe","delete":"styles_delete__3A5Wc","update":"styles_update__37CF1","add":"styles_add__fWvVC"};